import { Routes, RouterModule } from '@angular/router';
import { GuestApplyComponent } from './apply/apply.component';
import { GuestProceedComponent } from './proceeed/proceed.component';
import { GuestRegisterComponent } from './register/register.component';

const guestRoutes: Routes = [
  // guest routes
  // {
  //   path: 'apply',
  //   component: null,
  //   children: [
  //     {
  //       path: ':account_id/:funnel_id/:source',
  //       component: GuestAccountInboxInviteComponent,
  //     },
  //   ],
  // },
  {
    path: 'register/:account_id/:funnel_id/:source',
    component: GuestRegisterComponent,
  },
  {
    path: 'apply/:account_id/:funnel_id/:source',
    component: GuestApplyComponent,
  },
  {
    path: 'proceed/:application_id',
    component: GuestProceedComponent,
  }
];

export const GuestRouting = RouterModule.forChild(guestRoutes);
